"use strict";

exports.__esModule = true;
exports.PRESETS = void 0;

var _collageGallery = _interopRequireDefault(require("./collageGallery"));

var _masonryGallery = _interopRequireDefault(require("./masonryGallery"));

var _gridGallery = _interopRequireDefault(require("./gridGallery"));

var _thumbnailGallery = _interopRequireDefault(require("./thumbnailGallery"));

var _sliderGallery = _interopRequireDefault(require("./sliderGallery"));

var _slideshowGallery = _interopRequireDefault(require("./slideshowGallery"));

var _panoramaGallery = _interopRequireDefault(require("./panoramaGallery"));

var _columnGallery = _interopRequireDefault(require("./columnGallery"));

var _magicGallery = _interopRequireDefault(require("./magicGallery"));

var _fullsizeGallery = _interopRequireDefault(require("./fullsizeGallery"));

var _bricksGallery = _interopRequireDefault(require("./bricksGallery"));

var _mixGallery = _interopRequireDefault(require("./mixGallery"));

var _alternateGallery = _interopRequireDefault(require("./alternateGallery"));

var _emptyGallery = _interopRequireDefault(require("./emptyGallery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PRESETS = {
  CollageGallery: _collageGallery["default"],
  MasonryGallery: _masonryGallery["default"],
  GridGallery: _gridGallery["default"],
  ThumbnailGallery: _thumbnailGallery["default"],
  SliderGallery: _sliderGallery["default"],
  SlideshowGallery: _slideshowGallery["default"],
  PanoramaGallery: _panoramaGallery["default"],
  ColumnGallery: _columnGallery["default"],
  MagicGallery: _magicGallery["default"],
  FullsizeGallery: _fullsizeGallery["default"],
  BricksGallery: _bricksGallery["default"],
  MixGallery: _mixGallery["default"],
  AlternateGallery: _alternateGallery["default"],
  EmptyGallery: _emptyGallery["default"]
};
exports.PRESETS = PRESETS;